import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Brand, OfferStore, StoreAuthor, StoreResponse } from '../models/brand';
import { ApiResponse } from '../models/apiResponse';
import { GlobalComponent } from '../global-component';
import { SKIP_API_CACHE } from './cache-http.interceptor';
import { ApiCacheService } from './api-cache.service';

const baseUrl = GlobalComponent.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class BrandApiService {
  constructor(
    private httpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiCache: ApiCacheService
  ) { }

  getStores(
    isActive: number,
    isTop: number,
    recordsCount: number
  ): Observable<StoreResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<StoreResponse>(
        baseUrl +
        '/store/GetStoreMenus?isActive=' +
        isActive +
        '&isTop=' +
        isTop +
        '&recordsCount=' +
        recordsCount
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as StoreResponse);
  }

  getStoresBySearchQuery(searchTerm: string): Observable<StoreResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<StoreResponse>(
        baseUrl + '/store/GetUIStoresByName?SearchTerm=' + searchTerm
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as StoreResponse);
  }

  getStoreBySeoName(seoName: string): Observable<StoreResponse> {
    return this.httpClient.get<StoreResponse>(
      baseUrl + '/store/getStoreBySeoName?SeoName=' + seoName
    );
  }

  getActiveStores(): Observable<ApiResponse<Brand[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Brand[]>>(
        baseUrl + '/store/GetActiveStores'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Brand[]>);
  }

  getOfferStoreMenu(): Observable<ApiResponse<OfferStore[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<OfferStore[]>>(
        baseUrl +
        '/Store/GetOfferStores?isAll=true&isStoreOnly=false&isOfferStoreOnly=false'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<OfferStore[]>);
  }

  addBrand(store: OfferStore): Observable<ApiResponse<number>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.post<ApiResponse<number>>(
        baseUrl + '/store/AddOfferStore',
        store,
        { context: new HttpContext().set(SKIP_API_CACHE, true) }
      ).pipe(tap(() => this.apiCache.clearAll()));
    }
    return of({
      data: 0,
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<number>);
  }

  getRelatedStoresByStoreId(
    storeId: number,
    isStorePage: boolean
  ): Observable<ApiResponse<Brand[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Brand[]>>(
        baseUrl +
        '/store/GetRelatedStoresByStoreId?StoreId=' +
        storeId +
        '&isStorePage=' +
        isStorePage
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Brand[]>);
  }

  getStoreAuthorData(
    storeId: number
  ): Observable<ApiResponse<StoreAuthor>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<StoreAuthor>>(
        baseUrl +
        '/Users/GetAuthorData?StoreId=' +
        storeId
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<StoreAuthor>);
  }
}
